<!-- =========================================================================================
  File Name: OrderView.vue
  Description: Order View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="orderSheet-view-tab-tracking">

     <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span class="font-semibold">수령인</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          <vs-input class="w-full" v-model="order_data.recvUserName" v-validate="'required'"/>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span class="font-semibold">배송주소</span>
        </div>
        <div class="vx-col sm:w-2/3 flex flex-wrap">
          <div class="w-1/2">
            <vs-input class="w-full" disabled v-model="order_data.recvZipCode" v-validate="'required'" name="recvZipCode" />
            <span class="text-danger text-sm" v-show="errors.has('recvZipCode')">{{ errors.first('recvZipCode') }}</span>
          </div>
          <div class="w-1/2">
            <vs-button class="ml-4" @click="popupActive=true">주소 검색</vs-button>
          </div>
          <vs-input class="w-full mt-4" disabled v-model="order_data.recvZipName" v-validate="'required'" name="recvZipName" />
          <span class="text-danger text-sm" v-show="errors.has('recvZipName')">{{ errors.first('recvZipName') }}</span>

          <vs-input class="w-full mt-4" v-model="order_data.recvZipDetail" name="recvZipDetail" />
          <span class="text-danger text-sm" v-show="errors.has('recvZipDetail')">{{ errors.first('recvZipDetail') }}</span>
        </div>
      </div>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/3 w-full">
          <span class="font-semibold">학원주소</span>
        </div>
        <div class="vx-col sm:w-2/3 w-full">
          ({{ institute_data.zipCode }}) {{ institute_data.zipName }} {{ institute_data.zipDetail }}
        </div>
      </div>

    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full">
        <span class="font-semibold">배송방법</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-input class="w-full" v-model="order_data.deliverWay" v-validate="'required'"/>
      </div>
    </div>
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full">
        <span class="font-semibold">송장번호</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-input class="w-full" v-model="order_data.invoiceNumber" v-validate="'required'"/>
      </div>
    </div>
    <!-- <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full">
        <span class="font-semibold">배송정보 입력자</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-input class="w-full" v-model="deliverUserName" v-validate="'required'"/> 
      </div>
    </div> -->
    <div class="vx-row mb-6">
      <div class="vx-col sm:w-1/3 w-full">
        <span class="font-semibold">상태</span>
      </div>
      <div class="vx-col sm:w-2/3 w-full">
        <vs-select v-model="order_data.orderStatus" class="w-full" name="item-orderStatus" v-validate="'required'">
          <vs-select-item :key="item.value" :value="item.value" :text="item.text" v-for="item in orderStatusOptions" />
        </vs-select>
      </div>
    </div>


    <!-- Save & Cancel Button -->
    <div class="vx-row mt-8">
      <div class="vx-col sm:w-2/3 w-full ml-auto">
        <vs-button class="mr-3 mb-2" @click="confirmSaveChanges" :disabled="!validateForm">확인</vs-button>
        <vs-button color="warning" type="border" class="mb-2" @click="$router.go(-1)">취소</vs-button>
      </div>
    </div>

    <!-- Daum 우편번호 서비스 -->
    <vs-popup class="holamundo" title="주소 검색" :active.sync="popupActive">
      <p>
        <vue-daum-postcode @complete="this.daumPostCode" />
      </p>
    </vs-popup>
  </div>
</template>

<script>
import { VueDaumPostcode } from 'vue-daum-postcode'
import { fetchData, putData } from '@/api/module'

export default {
  components: {
    VueDaumPostcode
  },
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      order_data: JSON.parse(JSON.stringify(this.data)),
      popupActive: false,
      institute_data: null,
      orderStatusOptions: [
        {
          value: 0,
          text: '주문'
        },
        {
          value: 1,
          text: '결제완료'
        },
        {
          value: 2,
          text: '배송중'
        },
        {
          value: 3,
          text: '배송완료'
        },
        {
          value: 4,
          text: '거래완료'
        }
      ] 
    }
  },
  computed: {
    validateForm () {
      return !this.errors.any()
    },
    deliverUserName () {
      // const orderStatus = this.order_data.orderStatus
      const userName = ''
      // if (orderStatus === 0) { //주문
      //   userName = ''
      // } else if (orderStatus === 1) { //결제완료
      //   userName = ''
      // } else if (orderStatus === 2) { //배송중
      //   userName = ''
      // } else if (orderStatus === 3) { //베송완료
      //   userName = ''
      // } else if (orderStatus === 4) { //거래완료
      //   userName = ''
      // } else {
      //   userName = ''
      // }
      
      return userName
    }
  },
  methods: {
    daumPostCode (value) {
      this.order_data.recvZipCode = value.zonecode
      this.order_data.recvZipName = value.address

      this.popupActive = false
    },
    async loadIntituteInfo () {

      try {
        const { data } = await fetchData(`institute/${this.order_data.instituteSeq}`)
        this.institute_data = data.data

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    confirmSaveChanges () {

      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: '배송 정보 수정',
        text: '저장 하시겠습니까?',
        accept: this.saveChanges,
        acceptText: '저장'
      })
    },
    async saveChanges () {
      if (!this.validateForm) return

      try {
        const { data } = await putData('order-tracking', this.order_data)     
        console.log(data)

        this.$router.go(-1)

        this.showSaveChangesSuccess()

      } catch (error) {
        console.log(error)

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    },
    showSaveChangesSuccess () {
      this.$vs.notify({
        color: 'success',
        title: '배송 정보 수정',
        text: '저장 되었습니다.'
      })
    }
  },
  created () {
    this.loadIntituteInfo()
  }
}

</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-order-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: .8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width:370px) {
          display: block;
        }
      }
    }
  }
}


@media screen and (min-width:1201px) and (max-width:1211px),
only screen and (min-width:636px) and (max-width:991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

}

</style>
